import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { useEffect, useState } from 'react';
import { setBookableResourcesQuery } from '../../lib/Queries';
import Modal from '../Modal';
import TextInput from '../TextInput';
import { shouldShowCapacity } from '../../lib/BookableResourceHelpers.js';
import OptionalTimeZoneSelect from './OptionalTimeZoneSelect.jsx';
import SelectResourceType from './SelectResourceType.jsx';
import TextArea from '../TextArea.jsx';
import CustomFields from '../customfields/CustomFields.jsx';
import { ObjectTypes } from '../../lib/ObjectTypes.js';

const RenameBookableResource = ({ isOpen, onClose, resource }) => {
    const { save, isSaving } = useBusinessPostApi(
        `/bookable-resources/${resource?.id}`,
    );
    const [name, setName] = useState(resource?.name);
    const [type, setType] = useState(resource?.type);
    const [description, setDescription] = useState(resource?.description);
    const [timezone, setTimezone] = useState(resource?.timezone);

    const [capacity, setCapacity] = useState(resource?.capacity);

    const showCapacity = shouldShowCapacity(resource);
    const showTimezone = isOpen && resource?.type === 'Person';
    const showType = type && type !== 'Person';

    useEffect(() => {
        setName(resource?.name);
        setCapacity(resource?.capacity);
        setTimezone(resource?.timezone);
        setType(resource?.type);
        setDescription(resource?.description);
    }, [
        resource?.name,
        resource?.capacity,
        resource?.timezone,
        resource?.type,
    ]);

    function submit(ev) {
        ev.preventDefault();

        save({
            ...resource,
            type: type,
            name: name,
            capacity: capacity,
            timezone: timezone,
            description: description,
        }).then(result => {
            setBookableResourcesQuery(result.allBookableResources, true);
            onClose();
        });
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => {
                onClose();
                setName(resource?.name);
            }}
        >
            <form onSubmit={submit}>
                <TextInput
                    id="name"
                    value={name}
                    onChange={setName}
                    label="Name"
                    autoFocus={isOpen}
                />

                <TextArea
                    id="description"
                    label="Description"
                    placeholder="Description (optional)"
                    value={description}
                    onChange={setDescription}
                    className="mt-4"
                />

                {showCapacity && (
                    <TextInput
                        id="capacity"
                        value={capacity}
                        onChange={setCapacity}
                        label="How many are available for clients to book?"
                        className="mt-4"
                    />
                )}

                {showType && (
                    <div className="mt-4">
                        <SelectResourceType value={type} onChange={setType} />
                    </div>
                )}

                <CustomFields
                    type={ObjectTypes.BOOKABLE_RESOURCE}
                    id={resource?.id}
                    fields={resource?.custom_fields}
                    className="mt-4"
                    alwaysEdit={true}
                />

                {showTimezone && (
                    <OptionalTimeZoneSelect
                        className="mt-4 text-sm"
                        value={timezone}
                        onChange={setTimezone}
                        defaultLabel="Change time zone from default..."
                    />
                )}

                <button className="btn-save mt-4">
                    {isSaving ? 'Saving...' : 'Save Changes'}
                </button>
            </form>
        </Modal>
    );
};

export default RenameBookableResource;
